import { getCurrentSession } from 'remote/auth';
import { encryptCredit } from 'utils/encryption';
import { TokenExPublicKey, thDigitalUrl } from 'utils/environment';
import { ISOs, getCountryAndCurrencyCodes } from 'utils/form/constants';

import { ITHDigitalRequestBody, ITokenizeCard } from './types';

export const tokenizeCard: ITokenizeCard = async (reshapedPaymentValues, enableDirectPay, user) => {
  if (!enableDirectPay || !user) {
    return null;
  }
  try {
    // CC details encryption for TokenEx
    const encryptedCredit = await encryptCredit({
      credit: reshapedPaymentValues,
      fdPublicKey: TokenExPublicKey,
      isUsingTokenEx: true
    });
    const session = await getCurrentSession();
    const billingCountry = user.details?.isoCountryCode;
    const { countryCode } = getCountryAndCurrencyCodes(billingCountry as ISOs);
    const { cardNumber, expiryDate, securityCode, cardType } = encryptedCredit;

    const headers = {
      Authorization: `Bearer ${session?.getIdToken().getJwtToken()}`,
      'Content-Type': 'application/vnd.rbi.add-funding-card-direct-pay.v2+json'
    };

    const body: ITHDigitalRequestBody = {
      creditCard: {
        cardNumber,
        securityCode,
        expirationMonth: expiryDate?.month,
        expirationYear: expiryDate?.year,
        cardType,
        billing: {
          countryCode
        }
      }
    };
    // Post request to get a chaseProfileId
    const response = await fetch(`${thDigitalUrl}/v0/directpay`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body)
    });
    if (response.ok) {
      const { chaseProfileId } = await response.json();
      return chaseProfileId;
    }
    throw new Error('Error tokening card');
  } catch (err) {
    throw err;
  }
};
